import api from 'api';

export const loadInfluencerCampaignTable = api(
  'POST /api/influencers-campaigns/grid'
);

export const loadInfluencerCampaignDetails = api(
  'GET /api/influencers-campaigns/:id/details'
);

export const loadInfluencerCampaign = api('GET /api/influencers-campaigns/:id');

export const createInfluencerCampaign = api('POST /api/influencers-campaigns');

export const updateInfluencerCampaign = api(
  'PUT /api/influencers-campaigns/:id'
);

export const deleteInfluencerCampaign = api(
  'POST /api/influencers-campaigns/:id/delete'
);

export const exportInfluencersCampaignsTemplate = api(
  'POST /api/influencers-campaigns/export/template',
  {
    responseType: 'blob',
  }
);

export const exportInfluencersCampaignsSpendLog = api(
  'POST /api/influencers-campaigns/export/spend-log',
  {
    responseType: 'blob',
  }
);

export const uploadGGCampaigns = api(
  `POST /api/influencers-campaigns/gg-campaigns/import`
);

export const uploadUpdatedCampaigns = api(
  `POST /api/influencers-campaigns/updated-campaigns/import`
);

export const checkUploadUpdatedCampaigns = api(
  'GET /api/influencers-campaigns/updated-campaigns/import/:jobId/status'
);

export const checkUploadGGCampaigns = api(
  'GET /api/influencers-campaigns/gg-campaigns/import/:jobId/status'
);

export const addPromoCode = api(
  'POST /api/influencers-campaigns/bulk/add-promocode'
);

export const loadPromoCodes = api('GET /api/influencers/promo-codes');

export const addParametersToLink = api(
  'POST /api/influencers-campaigns/bulk/add-link-parameters'
);
